// England's NVZ and drinking-water safeguard zones live in their own England-only
// layer, separate from Protected sites, and render in Defra's own styling held
// down to a low opacity.
//
// WHERE THEY LIVE, which is the part that actually fixed BBB-456. These two cover
// a large share of England, so their fills swamped the map while they sat inside
// the merged protected-sites layer (then named "Regulatory areas"). Splitting them
// out is what fixes that, and
// Davin settled the reason on 18/08 after seeing the alternative working: "the
// chance to have 5 patterns/items overlayed on eachother is not good." Combined
// with one-visible-layer-at-a-time, a farmer opts into this wash to answer "am I
// in an NVZ" and never has it thrown over a layer they were already reading.
//
// HOW THEY DRAW, which took four attempts:
//
//   1. Tune the merged fill's opacity down. No value was faint enough to stop
//      them dominating and still readable, because they were sharing a layer.
//   2. Drop the fill, draw outlines client-side. Cost the source's own colours
//      and read as a different dataset from the Scottish NVZ layer.
//   3. Defra's WMS at FULL strength (13/08). Rejected on 18/08: "the nitrate and
//      water zones are like 100% opacity so i cant even see the map below them."
//   4. This. Defra's WMS, their styling, at a low opacity. Which is route 1's
//      mechanism, and it works now for the reason it failed then: there are only
//      two things in this layer instead of five, so the fill has far less to
//      compete with.
//
// A client-side hatch was built and was working (see svgHatchOverlay.js, which the
// three designations still use). Davin chose this instead, from a side-by-side
// render: Defra's magenta is what a farmer already sees on Defra's own viewer and
// on paper, and with only two categories in the layer a pattern is doing less work
// than it does for SSSI/SAC/SPA. The hatch route stays available if these ever get
// crowded again.
//
// Verified 13/08/2026: this NVZ endpoint returns tiles byte-identical to the
// geoservices/datasets/60be356d-… URL this file used to carry (md5 c4374095…), so
// there is one URL form for it rather than two.
export const NITRATE_WATER_SOURCES = [
  {
    id: 'nvz-2021-england',
    region: 'england',
    kind: 'wms',
    wmsBase:
      'https://environment.data.gov.uk/spatialdata/nitrate-vulnerable-zones-2021-designations/wms',
    layerName: 'Nitrate_Vulnerable_Zones_2021_Designations',
    // Defra's magenta at 0.30. Picked by eye on 18/08 against 0.45, which read as
    // too heavy once a zone filled the screen. Anything below about 0.25 stops
    // answering "am I inside one", which is the only question this layer exists
    // for, so there is not much room underneath this figure.
    defaultOpacity: 0.3,
    minZoom: 8,
    licenceStatus: 'verified',
    precedence: 100,
  },
  {
    id: 'drwpa-england',
    region: 'england',
    kind: 'wms',
    wmsBase:
      'https://environment.data.gov.uk/spatialdata/drinking-water-safeguards-surface-water/wms',
    layerName: 'Drinking_Water_Safeguard_Zones_Surface_Water',
    // Slightly stronger than NVZ's 0.30 because Defra draw this as a black
    // stipple on white, and a stipple loses its dots to the background faster
    // than a flat wash loses its colour.
    defaultOpacity: 0.35,
    minZoom: 8,
    licenceStatus: 'verified',
    // Above NVZ, matching the source order it had in the merged layer. Only
    // matters where the two overlap.
    precedence: 200,
  },
];

// Scotland's NVZ stays in the merged Protected sites layer. It is five small
// zones drawn in our own colourblind-safe renderer, not a nationwide wash, so it
// never had the legibility problem the England pair had — and keeping it there is
// what makes 'nitrate-water' England-only without any region gating of its own.
//
// Davin on 18/08, having looked at it: "regulatory layer makes sense in scotland:
// sssi sac spa + nvz, all clear, dont touch scotland." So the asymmetry between
// the two nations is intentional and is not a tidy-up waiting to happen.
export const NITRATE_SOURCES = [
  {
    id: 'nvz-scotland',
    region: 'scotland',
    kind: 'arcgis-rest',
    serviceUrl:
      'https://maps.gov.scot/server/rest/services/ScotGov/AgricultureEnvironment/MapServer',
    layerId: 5,
    // BBB-457: yellow outline + tint (colourblind-safe); no hatch for NVZ.
    rendererOverride: {
      fillColour: [242, 208, 36, 150],
      outlineColour: [201, 162, 39, 255],
      outlineWidth: 1.4,
    },
    minZoom: 8,
    licenceStatus: 'verified',
    precedence: 100,
  },
];
